function UnActiveTab() {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="16" cy="16" r="16" fill="#F3F1FF" />
            <circle cx="16" cy="16" r="6" fill="#FFFFFF" />
        </svg>
    );
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default UnActiveTab;
